// Thin wrappers over the room REST API. Same-origin in both dev (via Vite proxy)
// and production (Node serves the client), so relative URLs are all we need.

export async function createRoom(name, maxFeatures = null) {
  const res = await fetch('/api/rooms', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: name || null, maxFeatures }),
  })
  if (!res.ok) throw new Error('Could not create a room')
  return res.json()
}

export async function getRoomByCode(code) {
  const res = await fetch(`/api/rooms/code/${encodeURIComponent(code)}`)
  if (res.status === 404) return null
  if (!res.ok) throw new Error('Lookup failed')
  return res.json()
}

export async function getRoomById(id) {
  const res = await fetch(`/api/rooms/id/${encodeURIComponent(id)}`)
  if (res.status === 404) return null
  if (!res.ok) throw new Error('Lookup failed')
  return res.json()
}

export async function geocode(query) {
  const res = await fetch(`/api/geocode?q=${encodeURIComponent(query)}`)
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || 'Search failed')
  return data.results || []
}
